export default function createOnApolloLinkErrorHandler(onError: any): any {
  return (args: any) => {
    const { graphQLErrors, networkError, forward, operation } = args;
    const ctx = operation && operation.getContext();

    if (ctx) {
      const { mute } = ctx;
      if (mute) {
        return;
      }
    }

    switch (operation && operation.operationName) {
      case 'DeleteAllAccountPolicyEntities':
        return;

      // These batch queries can timeout but still resolve...
      // ... Use custom error handling, and skip showing the default toast.
      case 'CreateEntity':
      case 'CreateRelationship':
      case 'DeleteEntity':
      case 'DeleteRelationship':
        const { attempts = 0 } = operation.getContext();

        // Probably a cold-start, and the API likely successfully handled it.
        // ... Try up to 3 times, then give up. (Creates have same unique _key)
        if (attempts < 2) {
          console.warn(`Retry ${operation.operationName} #${attempts + 1}`);
          operation.setContext({ attempts: attempts + 1 });
          return forward(operation);
        }
        return;
    }

    if (graphQLErrors) {
      graphQLErrors.forEach(({ message, locations, path }: any) =>
        console.error(
          `[GraphQL error]: Message: ${message}, Location: ${JSON.stringify(
            locations
          )}, Path: ${path}`
        )
      );

      return onError(graphQLErrors);
    } else if (networkError) {
      // TODO: Add some retry logic.
      if (networkError.statusCode > 300) {
        return onError(networkError);
      }
    }
  };
}
